module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_online_support-e86a1ea6527cb94121931fdc8288bcf2.png";